import {ForwardedRef, forwardRef, ReactNode} from 'react';

import styled, {css, CSSProperties} from 'styled-components';

import {BannerType, BannerTypes} from 'shared/components/MessageBanner/Themes';
import {Spacing} from 'styles/Base';

const pageBannerStyles = css`
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  margin-bottom: 0;
`;

interface Props {
  type: BannerType;
  children?: ReactNode;
  $contextual?: boolean;
  $noMargin?: boolean;
  borderStyle?: CSSProperties;
  padding?: string;
  id?: string;
}

const Wrapper = forwardRef(({children, type, borderStyle, id, ...rest}: Props, ref: ForwardedRef<HTMLDivElement>) => (
  <div
    {...{id, ref}}
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    tabIndex={id ? 0 : undefined}
    {...rest}
    style={borderStyle && {...borderStyle, borderColor: BannerTypes[type].styles.border}}>
    {children}
  </div>
));

export default styled(Wrapper)<Props>`
  align-items: center;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: ${({padding}) => css`
    ${padding ? padding : Spacing.ONE};
  `};
  margin-bottom: ${({$noMargin}) => css`
      ${$noMargin ? '0' : Spacing.TWO};
    `}
    ${({type, borderStyle}) => css`
      background-color: ${BannerTypes[type].styles.background};
      color: ${BannerTypes[type].styles.text};
      ${!borderStyle && `border: 1px solid ${BannerTypes[type].styles.border};`}
    `};
  ${({$contextual}) => !$contextual && pageBannerStyles};
`;
